var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spa-button',{staticClass:"c-btn--w-large c-btn--center c-btn--positive c-btn--h-xlarge c-btn--ledian",attrs:{"type":"submit","mode":"primary"}},[_vm._t("default",[_vm._v("ログイン")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }